import { FC } from 'react';
import { useNavigate } from 'react-router';
import {
  Button,
  ButtonGroup,
  Container,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

type EmptyPagePropsType = {
  titleElement?: any;
  titleTxt?: string;
};

const EmptyPage: FC<EmptyPagePropsType> = ({ titleElement, titleTxt }) => {
  const navigate = useNavigate();

  const goHomeHandler = () => navigate('/');
  const goBackHandler = () => navigate(-1);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ width: '100%', height: '100vh' }}
    >
      <Container maxWidth="xs">
        <Paper sx={{ p: 3 }}>
          {titleElement
            ? titleElement
            : titleTxt && (
                <Typography
                  variant="h5"
                  align="center"
                  paragraph
                  sx={{ mb: 4 }}
                >
                  titleTxt
                </Typography>
              )}
          <ButtonGroup fullWidth variant="contained">
            <Button fullWidth size="large" onClick={goBackHandler}>
              بازگشت به صفحه قبل
            </Button>
            <Button fullWidth size="large" onClick={goHomeHandler}>
              رفتن به صفحه اصلی
            </Button>
          </ButtonGroup>
        </Paper>
      </Container>
    </Stack>
  );
};

export default EmptyPage;
